import React, { useContext } from 'react';

import { observer } from 'mobx-react-lite';

import { RootStoreContext } from 'index';
import useForm from 'hooks/useForm';
import { validateCheckboxField } from 'common/utils/validation.utils';
import TextInput from 'components/common/TextInput/TextInput';
import Checkbox from 'components/common/Checkbox/Checkbox';
import Button from 'components/common/Button/Button';
import { ApplicationRoute } from 'routes/routes.enums';
import { DoneIcon } from 'components/common/Icons/Icons';
import { notify } from 'components/common/Toast/toast.helpers';
import { ToastMessage } from 'components/common/Toast/toast.enums';

import styles from './SignMdaDialog.module.scss';
import { SignMdaDialogLabels } from './signMdaDialog.enums';

interface SignMdaDialogProps {
  changeDialogStep: () => void;
  setIsOpen: (isOpen: boolean) => void;
}

const SignMdaDialog = ({ changeDialogStep, setIsOpen }: SignMdaDialogProps) => {
  const { intermediaryApplicationsStore, authStore } = useContext(RootStoreContext);
  const { errors, values, setValue, handleSubmit } = useForm({
    defaultValues: {
      [SignMdaDialogLabels.AgreeWithMda]: false,
    },
    handleValidation: (fieldName, value) => {
      if (fieldName === SignMdaDialogLabels.AgreeWithMda) {
        return validateCheckboxField(value);
      }

      return '';
    },
  });
  const handleOpenMda = async (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    window.open(ApplicationRoute.MdaPreview, '_blank');
  };

  const handleConfirm = handleSubmit(async () => {
    await intermediaryApplicationsStore.signMasterDialerAgreement();
    await authStore.getAccount();
    setIsOpen(false);
    notify(ToastMessage.MdaSigned, 'success');
  });
  const handleShowDeclineDialog = () => {
    changeDialogStep();
  };

  return (
    <>
      <p className={styles.informationalText}>
        HFS is excited to offer you access to the invite-only HFS Contractor Portal, only available to select HFS
        Contractors. Let’s get started.
      </p>
      <ul>
        <li className={styles.informationalText}>
          <DoneIcon />
          $$$ Special Cash Rewards $$$
        </li>
        <li className={styles.informationalText}>
          <DoneIcon />
          Portal to track Customer Loan Progress
        </li>
        <li className={styles.informationalText}>
          <DoneIcon />
          Advanced Trainings
        </li>
        <li className={styles.informationalText}>
          <DoneIcon />
          Branded Collateral
        </li>
        <li className={styles.informationalText}>
          <DoneIcon />
          Access to More Funding Options
        </li>
      </ul>
      <TextInput
        className={styles.input}
        containerClassName={styles.inputContainer}
        labelTitle={SignMdaDialogLabels.WhoSign}
        name={SignMdaDialogLabels.WhoSign}
        value={`${authStore.account?.firstName} ${authStore.account?.lastName}`}
        disabled={true}
      />
      <Checkbox
        onChange={(value) => setValue(SignMdaDialogLabels.AgreeWithMda, !values[SignMdaDialogLabels.AgreeWithMda])}
        errorMessage={errors[SignMdaDialogLabels.AgreeWithMda]}
        label={
          <p>
            I/We agree to the{' '}
            <span className={styles.checkboxTextAsLink} onClick={handleOpenMda}>
              Master Dealer Agreement
            </span>
          </p>
        }
      />
      <Button
        className={styles.button}
        onClick={handleConfirm}
        isLoading={intermediaryApplicationsStore.isMasterDialerAgreementLoading}
      >
        Confirm
      </Button>
      <Button className={styles.frameButton} onClick={handleShowDeclineDialog} variant={'underline'}>
        Decline
      </Button>
    </>
  );
};

export default observer(SignMdaDialog);
